import React from 'react';
import {Colors} from '../../styles/Colors';
import {GlobalStyleAttributes} from '../../styles/GlobalStyles';
import HStack from './Layout/HStack';
import AppText from './AppText';

const StepCircle = ({stepNumber}) => (
    <HStack
        alignItems={'center'}
        justifyContent={'center'}
        style={{
            width: '24px',
            height: '24px',
            borderRadius: '50%',
            backgroundColor: Colors.newDesign.mainBlue,
            flexShrink: 0,
        }}
    >
        <AppText fontSize={GlobalStyleAttributes.fonts.heading4} boldFont color={Colors.newDesign.white}>
            {stepNumber}
        </AppText>
    </HStack>
);

export default StepCircle;
